<div class="allergen d-flex flex-wrap" *ngIf="attributes?.length > 0">
  <div
    *ngIf="isAllergenSelected('VEGETARIAN')"
    class="icon icon-vegetarian green"
    title="{{
      'public.store.catalog.offer.characteristics.vegetarian' | translate
    }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('VEGAN')"
    class="icon icon-vegan green"
    title="{{ 'public.store.catalog.offer.characteristics.vegan' | translate }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('HALAL')"
    class="icon icon-halal"
    title="{{ 'public.store.catalog.offer.characteristics.halal' | translate }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('NUT_FREE')"
    class="icon icon-Nutfree green"
    title="{{
      'public.store.catalog.offer.characteristics.nutFree' | translate
    }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('GLUTEN_FREE')"
    class="icon icon-glutenFree green"
    title="{{
      'public.store.catalog.offer.characteristics.glutenFree' | translate
    }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('DAIRY_FREE')"
    class="icon icon-dairyFree green"
    title="{{
      'public.store.catalog.offer.characteristics.dairyFree' | translate
    }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('SUGAR_FREE')"
    class="icon icon-sugarFree green"
    title="{{
      'public.store.catalog.offer.characteristics.sugarFree' | translate
    }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('WITH_STEVIA')"
    class="icon icon-withStevia green"
    title="{{
      'public.store.catalog.offer.characteristics.withStevia' | translate
    }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('SPICY1')"
    class="icon icon-spicy_1"
    title="{{ 'public.store.catalog.offer.characteristics.spicy' | translate }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('SPICY2')"
    class="icon icon-spicy_2"
    title="{{ 'public.store.catalog.offer.characteristics.spicy' | translate }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('SPICY3')"
    class="icon icon-spicy_3"
    title="{{ 'public.store.catalog.offer.characteristics.spicy' | translate }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('FROZEN_INGREDIENTS')"
    class="icon icon-frozenIngredients"
    title="{{
      'public.store.catalog.offer.characteristics.frozenIngredients' | translate
    }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('CELERY')"
    class="icon icon-celery"
    title="{{
      'public.store.catalog.offer.characteristics.celery' | translate
    }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('CEREALS_WITH_WHEAT')"
    class="icon icon-wheat"
    title="{{ 'public.store.catalog.offer.characteristics.wheat' | translate }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('CRUSTACEANS')"
    class="icon icon-crustaceans"
    title="{{
      'public.store.catalog.offer.characteristics.crustaceans' | translate
    }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('EGG')"
    class="icon icon-eggs"
    title="{{ 'public.store.catalog.offer.characteristics.eggs' | translate }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('FISH')"
    class="icon icon-fish"
    title="{{ 'public.store.catalog.offer.characteristics.fish' | translate }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('LUPIN')"
    class="icon icon-lupin"
    title="{{ 'public.store.catalog.offer.characteristics.lupin' | translate }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('MILK')"
    class="icon icon-milk"
    title="{{ 'public.store.catalog.offer.characteristics.milk' | translate }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('MOLLUSCS')"
    class="icon icon-molluscs"
    title="{{
      'public.store.catalog.offer.characteristics.molluscs' | translate
    }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('MUSTARD')"
    class="icon icon-mustard"
    title="{{
      'public.store.catalog.offer.characteristics.mustard' | translate
    }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('NUTS')"
    class="icon icon-nuts"
    title="{{ 'public.store.catalog.offer.characteristics.nuts' | translate }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('PEANUT')"
    class="icon icon-peanuts"
    title="{{
      'public.store.catalog.offer.characteristics.peanuts' | translate
    }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('SESAME')"
    class="icon icon-sesame"
    title="{{
      'public.store.catalog.offer.characteristics.sesame' | translate
    }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('SOYA')"
    class="icon icon-soya"
    title="{{ 'public.store.catalog.offer.characteristics.soya' | translate }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('SULPHUR_DIOXIDE')"
    class="icon icon-sulphur-dioxide"
    title="{{
      'public.store.catalog.offer.characteristics.sulphurDioxide' | translate
    }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('BARLEY')"
    class="icon icon-barley"
    title="{{
      'public.store.catalog.offer.characteristics.barley' | translate
    }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('CINNAMON')"
    class="icon icon-cinnamon"
    title="{{
      'public.store.catalog.offer.characteristics.cinnamon' | translate
    }}"
  ></div>
  <div
    *ngIf="isAllergenSelected('CITRIC_ACID')"
    class="icon icon-citricAcid"
    title="{{
      'public.store.catalog.offer.characteristics.citricAcid' | translate
    }}"
  ></div>
</div>
